import type {UpmPlantsContextValue, PlantIdsPerCountryMap} from '../types'

export const getPlantIdsPerCountryMap = (
  upmPlants: UpmPlantsContextValue
): PlantIdsPerCountryMap => {
  return Object.values(upmPlants).reduce((acc, plant) => {
    if (acc[plant.country]) acc[plant.country].push(plant.plantId)
    else acc[plant.country] = [plant.plantId]
    return acc
  }, {})
}
